import React from 'react';
import * as storageService from '../../services/localStorageService';
import * as apiParticulierService from '../../services/apiParticulierService';
import * as apiFlow from '../../services/apiFlowService';
import { isAdmin, isLocal, isLocalOrDev } from '../../services/tools/generalTools';

import TemplateEmpty from '../../assets/json/template-audit.json';
import TemplateFilled from '../../assets/json/template-audit-filled.json';

import '../../assets/style/button.scss';

// j'ai viré les trucs action logement le 06/11/2025, voir les comit avant cette date pour les options de remplissages éventuelles
// et j'ai déplacé, uniqueemnt dans audit.tsx, le AdminBar

const DEFAULT_FILLED_PHONE = TemplateFilled.step1.userTelephone.value;
const DEFAULT_FILLED_EMAIL = TemplateFilled.step1.userEmail.value;

const AdminBar: React.FC = () => {
    const agent = storageService.getCurrentAgent();
    const auditType = storageService.getCurrentAuditType();
    const flowId = localStorage.getItem('flowId');

    const showAdminBar = isAdmin(agent.agentCode) || isLocalOrDev();

    if (!showAdminBar) {
        return null;
    }

    return (
        <div className="navbar shadow-sm fixed-bottom bg-white" style={{ height: 'auto' }}>
            <div className="container">
                <div className="d-flex w-100 max-nav-bar-height">
                    <div className={'d-inline-flex ms-auto me-2'}>
                        <button
                            className={'btn btn-success'}
                            onClick={async () => {
                                let filled = JSON.stringify(TemplateFilled);
                                // En local, on remplit avec le numéro de téléphone de l'env
                                if (
                                    isLocal() &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_PHONE !== undefined &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_PHONE.length === 10
                                ) {
                                    filled = filled.replace(DEFAULT_FILLED_PHONE, process.env.REACT_APP_AUTO_FILL_DEFAULT_PHONE);
                                }
                                if (
                                    isLocal() &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_EMAIL !== undefined &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_EMAIL.length !== 0
                                ) {
                                    filled = filled.replace(DEFAULT_FILLED_EMAIL, process.env.REACT_APP_AUTO_FILL_DEFAULT_EMAIL);
                                }

                                //let empty = JSON.stringify(TemplateEmpty);

                                let EmptyAndStep1 = { ...TemplateEmpty, step1: JSON.parse(filled).step1 };

                                storageService.setAudit(EmptyAndStep1);

                                if (!auditType || !apiFlow.isAuditType(auditType)) {
                                    throw new Error("Impossible de déterminer le type d'audit");
                                }
                                // Création de l'audit si pas encore existant
                                if (!flowId) {
                                    await apiParticulierService.createAuditFlow();
                                }

                                // Mise à jour de l'audit en base
                                await apiParticulierService.updateAuditDataService();
                                // Rechargement de la page
                                window.location.reload();
                            }}
                        >
                            <span>Remplir step 1</span>
                        </button>
                        <button
                            className={'btn btn-success'}
                            onClick={async () => {
                                let intermediate = JSON.stringify(TemplateFilled);

                                // En local, on remplit avec le numéro de téléphone de l'env
                                if (
                                    isLocal() &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_PHONE !== undefined &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_PHONE.length === 10
                                ) {
                                    intermediate = intermediate.replace(DEFAULT_FILLED_PHONE, process.env.REACT_APP_AUTO_FILL_DEFAULT_PHONE);
                                }
                                if (
                                    isLocal() &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_EMAIL !== undefined &&
                                    process.env.REACT_APP_AUTO_FILL_DEFAULT_EMAIL.length !== 0
                                ) {
                                    intermediate = intermediate.replace(DEFAULT_FILLED_EMAIL, process.env.REACT_APP_AUTO_FILL_DEFAULT_EMAIL);
                                }

                                storageService.setAudit(JSON.parse(intermediate));

                                if (!auditType || !apiFlow.isAuditType(auditType)) {
                                    throw new Error("Impossible de déterminer le type d'audit");
                                }
                                // Création de l'audit si pas encore existant
                                if (!flowId) {
                                    await apiParticulierService.createAuditFlow();
                                }

                                // Mise à jour de l'audit en base
                                await apiParticulierService.updateAuditDataService();
                                // Rechargement de la page
                                window.location.reload();
                            }}
                        >
                            <span>Remplir intégralement l'audit</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminBar;
